unable to read source [project]/node_modules/src/image-assets.ts